import { useState } from "react";
import "./CampaignRequest.css";

import {
  createOperationalRequest,
} from "../../../api/CareerApi";

const CampaignRequest = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    workEmail: "",
    phoneNumber: "",
    companyName: "",
    budget: "",
    challenges: "",
    privacyPolicyAgreement: false,
  });

  const [isProgress, setIsProgress] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (isProgress || isSubmitted) {
      return;
    }

    if (!formData.privacyPolicyAgreement) {
      return;
    }

    const data = new FormData();

    data.append("full_name", formData.fullName.trim());
    data.append("work_email", formData.workEmail.trim());
    data.append("phone_number", formData.phoneNumber.trim());
    data.append("company_name", formData.companyName.trim());

    if (formData.budget) {
      data.append(
        "expected_monthly_campaign_budget",
        formData.budget
      );
    }

    if (formData.challenges) {
      data.append(
        "operational_challenges",
        formData.challenges.trim()
      );
    }

    data.append(
      "privacy_policy_agreement",
      String(formData.privacyPolicyAgreement)
    );

    createOperationalRequest(
      data,
      setIsProgress,
      () => {
        setIsSubmitted(true);

        setFormData({
          fullName: "",
          workEmail: "",
          phoneNumber: "",
          companyName: "",
          budget: "",
          challenges: "",
          privacyPolicyAgreement: false,
        });
      },
      () => {
        alert("Failed to submit operational request.");
      }
    );
  };

  const handleNewRequest = () => {
    setIsSubmitted(false);
  };

  return (
    <section className="campaign-request">
      <div className="campaign-request__card">

        {isSubmitted ? (
          <div className="campaign-request__success">
            <div className="campaign-request__success-icon">
              ✓
            </div>

            <h2>
              Request submitted successfully!
            </h2>

            <p>
              Thank you for reaching out to Xyncely.
              Our team will review your campaign requirements
              and get back to you soon.
            </p>

            <button
              type="button"
              className="campaign-request__button"
              onClick={handleNewRequest}
            >
              Submit Another Request
            </button>
          </div>
        ) : (
          <>
            <h2>
              Request a campaign brief review
            </h2>

            <form
              className="campaign-request__form"
              onSubmit={handleSubmit}
            >

              {/* FULL NAME */}
              <div className="campaign-request__field">
                <label htmlFor="fullName">
                  Full Name <span>*</span>
                </label>

                <input
                  id="fullName"
                  name="fullName"
                  type="text"
                  placeholder="Your Name"
                  value={formData.fullName}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* WORK EMAIL */}
              <div className="campaign-request__field">
                <label htmlFor="workEmail">
                  Work Email <span>*</span>
                </label>

                <input
                  id="workEmail"
                  name="workEmail"
                  type="email"
                  placeholder="mail@company.com"
                  value={formData.workEmail}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* MOBILE NUMBER */}
              <div className="campaign-request__field">
                <label htmlFor="phoneNumber">
                  Mobile Number <span>*</span>
                </label>

                <input
                  id="phoneNumber"
                  name="phoneNumber"
                  type="tel"
                  placeholder="Number"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* COMPANY NAME */}
              <div className="campaign-request__field">
                <label htmlFor="companyName">
                  Company Name <span>*</span>
                </label>

                <input
                  id="companyName"
                  name="companyName"
                  type="text"
                  placeholder="Brand Co."
                  value={formData.companyName}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* BUDGET */}
              <div className="campaign-request__field">
                <label htmlFor="budget">
                  Expected Monthly Campaign Budget
                </label>

                <select
                  id="budget"
                  name="budget"
                  value={formData.budget}
                  onChange={handleChange}
                >
                  <option value="" disabled>
                    Select budget
                  </option>

                  <option value="10k-50k">
                    $10,000 - $50,000 / month
                  </option>

                  <option value="50k-100k">
                    $50,000 - $100,000 / month
                  </option>

                  <option value="100k+">
                    $100,000+ / month
                  </option>
                </select>
              </div>

              {/* OPERATIONAL CHALLENGES */}
              <div className="campaign-request__field">
                <label htmlFor="challenges">
                  Tell us about your operational challenges
                </label>

                <textarea
                  id="challenges"
                  name="challenges"
                  placeholder="Briefly describe what platforms you run on and what is currently holding your workflow back..."
                  value={formData.challenges}
                  onChange={handleChange}
                />
              </div>

              {/* PRIVACY / CONSENT */}
              <label className="campaign-request__checkbox">
                <input
                  type="checkbox"
                  name="privacyPolicyAgreement"
                  checked={formData.privacyPolicyAgreement}
                  onChange={handleChange}
                  required
                />

                <span>
                  I agree to the Xyncely privacy policy and
                  communication terms.
                </span>
              </label>

              {/* SUBMIT */}
              <button
                type="submit"
                className="campaign-request__button"
                disabled={isProgress}
              >
                {isProgress
                  ? "Submitting..."
                  : "Send Operational Request"}
              </button>

            </form>
          </>
        )}

      </div>
    </section>
  );
};

export default CampaignRequest;